var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconfeatherMessageSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-square",
    "data-name": "Icon feather-message-square",
    d: "M4.557,22.6a.957.957,0,0,1-.957-.957V6.456A2.859,2.859,0,0,1,6.456,3.6H19.744A2.859,2.859,0,0,1,22.6,6.456v9.492A2.859,2.859,0,0,1,19.744,18.8H8.751L5.234,22.32A.957.957,0,0,1,4.557,22.6Zm1.9-17.086a.942.942,0,0,0-.941.941V19.332l2.163-2.163a.957.957,0,0,1,.677-.28h11.39a.942.942,0,0,0,.941-.941V6.456a.942.942,0,0,0-.941-.941Z",
    transform: "translate(-3.6 -3.6)",
    fill: "#4e4e4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherMessageSms);
export default __webpack_public_path__ + "static/media/Icon feather-message-sms.eaac3ad1612395149bb941df9241037f.svg";
export { ForwardRef as ReactComponent };